import React from 'react'
import styles from './sell.module.less'
import { saleCountFormat } from '@/utils/utils'
export default ({ count = 0, hide = false }) =>
  !hide ? (
    <span className={styles.sell}>累计热销{saleCountFormat(count)}件</span>
  ) : null
